import { get, forEach, uniqBy } from 'lodash';
import { comparableDate } from '../../../common/formattedDate';

const now = comparableDate(new Date());

export default function NFSPackageDetail(responses) {
  const packageMapping = {
    pkg_no: 'Details.Id',
    pkg_code: 'Details.Code',
    description: 'Details.Description',
    pkg_type: 'Details.Type.Description',
    text1: 'Details.Text1',
    text2: 'Details.Text2',
    text3: 'Details.Text3',
    text4: 'Details.Text4',
    facility_desc: 'Details.Facility.Description',
    on_sale_ind: false,
    seat_ind: 'ModeOfSale.SeatIndicator',
    print_ind: 'ModeOfSale.PrintIndicator',
    zmap_no: 'Details.ZoneMap.Id',
    season_no: 'Details.Season.Id',
    season_desc: 'Details.Season.Description',
    num_perf_min: 'Details.MinimumPerformances',
    num_perf_max: 'Details.MaximumPerformances',
    flex_ind: 'Y',
  };

  const performanceGroupMapping = {
    perf_group_no: 'Id',
    num_perf_min: 'MinimumPerformances',
    num_perf_max: 'MaximumPerformances',
    description: 'Description',
    display_by_zone: null,
    ranking: 'Rank',
  };

  const performanceMapping = {
    perf_no: 'PerformanceGroupPerformanceDetails[_I_].PerformanceId',
    description: 'PerformanceGroupPerformanceDetails[_I_].PerformanceDescription',
    text1: null,
    text2: null,
    text3: null,
    text4: null,
    perf_dt: 'PerformanceGroupPerformanceDetails[_I_].PerformanceDateTime',
    composerln: null,
    facility_desc: 'PerformanceGroupPerformanceDetails[_I_].Facility',
    perf_group_no: 'Id',
    season_no: 'Season.Id',
    season_desc: 'Season.Description',
    on_sale_ind: 'PerformanceGroupPerformanceDetails[_I_].AvailableIndicator',
    performance_type: null,
    perf_type_id: null,
    zmap_no: 'PerformanceGroupPerformanceDetails[_I_].ZoneMapId',
    facility_no: 'Performance.FacilityId',
    prod_season_no: 'Performance.ProductionSeason.Id',
    perf_status: null,
    perf_status_desc: null,
    zone_no: null,
    zone_description: null,
    zone_time: null,
  };

  const priceTypeMapping = {
    price_type: 'PriceTypeId',
    description: 'Description',
    short_desc: 'ShortDescription',
    alias_description: 'AliasDescription',
    category: null,
    def_price_type: 'DefaultIndicator',
    promo: 'Offer',
    promo_rank: 'Rank',
    promo_max: 'MaxSeats',
    promo_text: 'Terms',
  };

  const mapped = {
    Package: {},
    PerformanceGroup: [],
    Performance: [],
    PriceType: [],
    // We don't use these
    WebContent: [],
    // We don't use these
    PerformanceWebContent: [],
  };

  const [ detailsResponse, modesOfSaleResponse, priceTypesResponse, performancesResponse ] = responses;

  const mosDetails = {
    Details: detailsResponse.result,
    ModeOfSale: modesOfSaleResponse.result.length ? modesOfSaleResponse.result[0] : null,
  };

  forEach(packageMapping, (property, key) => {
    if (key === 'flex_ind') {
      mapped.Package[key] = property;
    } else if (key === 'on_sale_ind') {
      const startDate = get(mosDetails, 'ModeOfSale.StartDateTime', null);
      const endDate = get(mosDetails, 'ModeOfSale.EndDateTime', null);

      if (!startDate || !endDate) {
        mapped.Package[key] = false;
      } else {
        mapped.Package[key] = (
         comparableDate(startDate) < now &&
         comparableDate(endDate) > now
        );
      }
    } else {
      mapped.Package[key] = get(mosDetails, property, null);
    }
  });

  detailsResponse.result.PerformanceGroupDetails.forEach(detail => {
    detail.Season = detailsResponse.result.Season;

    const group = {};

    forEach(performanceGroupMapping, (property, key) => {
      if (!property) {
        group[key] = null;
      } else {
        group[key] = get(detail, property, null);
      }
    });

    mapped.PerformanceGroup.push(group);

    for (let i = 0; i < detail.PerformanceGroupPerformanceDetails.length; i++) {
      detail.Performance = performancesResponse.result.find(performance => {
        return performance.Id === detail.PerformanceGroupPerformanceDetails[i].PerformanceId;
      });

      const performance = {};

      forEach(performanceMapping, (property, key) => {
        if (property === null) {
          performance[key] = null;
        } else {
          performance[key] = get(detail, property.replace('_I_', i), null);
        }
      });

      mapped.Performance.push(performance);
    }
  });

  const uniquePriceTypes = uniqBy(priceTypesResponse.result, 'PriceTypeId');

  uniquePriceTypes.forEach(uniquePriceType => {
    const priceType = {};

    forEach(priceTypeMapping, (property, key) => {
      if (property === null) {
        priceType[key] = null;
      } else {
        priceType[key] = get(uniquePriceType, property, null);
      }
    });

    mapped.PriceType.push(priceType);
  });

  return mapped;
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/tessitura/REST/maps/NFSPackageDetail.js